// extracted by mini-css-extract-plugin
module.exports = {"box":"Selector_box__19K9S","label":"Selector_label__WMv_x"};